var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "g-px g-mb" }, [
    _c("div", { staticClass: "row-c-xl" }, [
      _c("div", { staticClass: "grid-block" }, [
        _c("div", { staticClass: "grid-block__nav" }, [
          _c(
            "ul",
            _vm._l(_vm.content, function(item, index) {
              return _c("li", { key: index }, [
                _c(
                  "a",
                  {
                    directives: [
                      { name: "smooth-scroll", rawName: "v-smooth-scroll" }
                    ],
                    class: {
                      active:
                        _vm.activeBlock === "" + item.label.replace(" ", "")
                    },
                    attrs: { href: "#" + item.label.replace(" ", "") }
                  },
                  [_vm._v(_vm._s(item.label))]
                )
              ])
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid-block__content" }, [
          _c(
            "div",
            { staticClass: "left" },
            _vm._l(_vm.firstColumnCards, function(card, index) {
              return _c("div", {
                key: index,
                staticClass: "card-wrapper card-wrapper--grid",
                attrs: { "data-name": "" + card.label.replace(" ", "") },
                domProps: { innerHTML: _vm._s(card.card) }
              })
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right" },
            _vm._l(_vm.secondColumnCards, function(card, index) {
              return _c("div", {
                key: index,
                staticClass: "card-wrapper card-wrapper--grid",
                attrs: { "data-name": "" + card.label.replace(" ", "") },
                domProps: { innerHTML: _vm._s(card.card) }
              })
            }),
            0
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }